// api
import { fetchApi } from '@/api'
// actions
const papeleriaProductsAll = (context) => {
  let url = 'inventory/products/productsPapeleria'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_PRODUCTS_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsForm = (context) => {
  let url = 'inventory/products/create'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_PRODUCTS_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsShow = (context, payload) => {
  console.log(payload)
  let obj = JSON.parse(payload)
  let data = {}
  let url = 'inventory/products/' + obj.id + '/editPaper'
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_PRODUCTS_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const papeleriaProductsCreate = (context, payload) => {
  let url = 'inventory/products/createPapeleria'
  return fetchApi(url, payload, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('PAPELERIA_PRODUCTS_CREATE', response)
     // window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsUpdate = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'PUT')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_UPDATE', response)
      window.history.back()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsDelete = (context, payload) => {
  let obj = JSON.parse(payload)
  let url = 'inventory/products/' + obj.id
  return fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('PAPELERIA_PRODUCTS_DELETE', response)
      location.reload()
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaProductsAdd = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/add'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('PAPELERIA_PRODUCTS_ADD', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

const papeleriaProductsMinus = (context, payload) => {
  let obj = JSON.parse(payload)
  var count = prompt('Ingrese la cantidad')
  if (count != null) {
    obj.count = count
    let json = JSON.stringify(obj)
    let url = 'inventory/products/' + obj.id + '/minus'
    return fetchApi(url, json, 'POST')
      .then((response) => {
        context.commit('PAPELERIA_PRODUCTS_MINUS', response)
        location.reload()
      })
      .catch((error) => {
        // eslint-disable-next-line
        console.error(error)
      })
  }
}

export default {
  papeleriaProductsAll,
  papeleriaProductsForm,
  papeleriaProductsShow,
  papeleriaProductsCreate,
  papeleriaProductsUpdate,
  papeleriaProductsDelete,
  papeleriaProductsAdd,
  papeleriaProductsMinus
}



// WEBPACK FOOTER //
// ./src/store/modules/papeleria/products/actions.js